// =============================================================================
// HUB CONFORMITÉ - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Le contenu historique (5 KPIs, 2 pipelines, évolution dépôts, MDPH,
// suivi par installateur) a été extrait en 6 widgets dans
// frontend/src/widgets/conformite/, catalogués côté serveur
// (backend/dashboard/catalog.py) et résolus via la cascade dashboard_layouts.
//
// Les widgets sensibles (pipeline avances, suivi par installateur) sont
// déjà filtrés au niveau du catalogue par roles=["admin", "commercial"] —
// les installateurs externes ne les recevront pas dans leur liste.
//
// L'ancien rendu monolithique reste accessible dans l'historique git.
// =============================================================================
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function DashboardConformite({ tenantId }) {
  return (
    <DashboardGrid hub="conformite" title="Dashboard Conformité" />
  );
}
